import { defineMessages } from 'react-intl';

export default defineMessages({
    backToTopLabel: {
        id: "agent.views.Back to top",
        defaultMessage: "Back to top"
    }
});
